// Max & Min values for storage products
export enum CloudM365 {
  MAX = 1000,
  MIN = 0,
  DEFAULT = 500,
}

export enum CloudEntra {
  MAX = 1000,
  MIN = 0,
  DEFAULT = 500,
}

export enum CloudSalesforce {
  MAX = 1000,
  MIN = 0,
  DEFAULT = 500,
}

export enum CloudD365 {
  MAX = 1000,
  MIN = 0,
  DEFAULT = 500,
}

export enum CloudGW {
  MAX = 1000,
  MIN = 0,
  DEFAULT = 500,
}

// Part Numbers
export enum M365 {
  STORAGE = 'D09S8ZX',
  WH_STORAGE = 'D09S9ZX',
}

export enum ENTRA {
  STORAGE = 'D0EQHZX',
  WH_STORAGE = '',
}

export enum SALESFORCE {
  STORAGE = 'D0BY8ZX',
  WH_STORAGE = 'D0BYAZX',
}

export enum D365 {
  STORAGE = 'D0DGXZX',
  WH_STORAGE = 'D0DGZZX',
}

export enum GW {
  STORAGE = 'D0HDUZX',
  WH_STORAGE = 'D0HDWZX',
}

export const DISCOUNTS = 0.9; // 10%
export const CUSTOMISED_QUOTE = 500;
